import { useEffect } from 'react';

import type { RecommendedPost } from '~/interfaces/recommended_post';

import { useNonRevalidatingFetcher } from '../useNonRevalidatingFetcher';

type FetcherData = {
  recommendedPosts: RecommendedPost[];
};

const useRecommendedPosts = (postId: string, isDraft = false) => {
  const fetcher = useNonRevalidatingFetcher<() => Promise<FetcherData>>();

  useEffect(() => {
    if (postId && !isDraft) {
      fetcher.load(`/recommended_posts?post_id=${postId}`);
    }
  }, [postId]);

  return fetcher?.data?.recommendedPosts || [];
};

export default useRecommendedPosts;
